// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__CGUXr","tab":"ProcedureTabs_tab__3JBWc"};